
    // Switch between history views
    function switchHistoryView() {
      const historyType = document.getElementById('historyType').value;
      
      // Hide all history sections
      document.getElementById('tradesHistory').classList.add('hidden');
      document.getElementById('depositsHistory').classList.add('hidden');
      document.getElementById('withdrawalsHistory').classList.add('hidden');
      
      // Show selected history section
      if (historyType === 'trades') {
        document.getElementById('tradesHistory').classList.remove('hidden');
      } else if (historyType === 'deposits') {
        document.getElementById('depositsHistory').classList.remove('hidden');
      } else if (historyType === 'withdrawals') {
        document.getElementById('withdrawalsHistory').classList.remove('hidden');
      }
    }
    
    // Refresh current history view
    function refreshCurrentHistory() {
      const historyType = document.getElementById('historyType').value;
      
      if (historyType === 'trades') {
        window.loadTradeHistory();
      } else if (historyType === 'deposits') {
        window.loadDepositHistory();
      } else if (historyType === 'withdrawals') {
        window.loadWithdrawalHistory();
      }
    }
    
    // Make functions globally available
    window.switchHistoryView = switchHistoryView;
    window.refreshCurrentHistory = refreshCurrentHistory;
    
    // Highlight active navigation link
    document.addEventListener('DOMContentLoaded', () => {
      const currentPage = 'wallet';
      const navLinks = document.querySelectorAll('[data-page]');
      
      navLinks.forEach(link => {
        if (link.getAttribute('data-page') === currentPage) {
          link.classList.remove('nav-link');
          link.classList.add('nav-link-active');
        }
      });
    });

    // Check if user is logged in and load profile
    const token = localStorage.getItem('token') || localStorage.getItem('authToken');
    if (!token) {
      window.location.href = '/login.html?redirect=/wallet.html';
    } else {
      // Show page content after authentication check passes
      document.querySelector('.page-content').classList.add('authenticated');
      // Display user email
      fetch((window.location.hostname === 'localhost' ? 'http://localhost:3000' : 'https://coinlance.org') + '/api/v1/users/profile', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => {
        if (response.status === 401 || response.status === 404) {
          // Token invalid or user not found, redirect to login
          localStorage.removeItem('token');
          localStorage.removeItem('authToken');
          localStorage.removeItem('user');
          window.location.href = '/login.html?redirect=/wallet.html';
          return null;
        }
        return response.json();
      })
      .then(data => {
        if (data && data.user && data.user.email) {
          document.getElementById('userEmailDisplay').textContent = data.user.email;
        }
      })
      .catch(error => console.error('Error loading profile:', error));
    }

    // Logout handler
    document.getElementById('logoutBtn')?.addEventListener('click', () => {
      localStorage.removeItem('token');
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      window.location.href = '/login.html';
    });

    // Deposit functions
    const API_BASE = window.location.hostname === 'localhost' ? 'http://localhost:3000/api/v1' : 'https://coinlance.org/api/v1';
    let walletAddresses = {};
    let proofBase64 = null;

    // Load wallet addresses
    async function loadWalletAddresses() {
      try {
        const response = await fetch(`${API_BASE}/auth/wallet-addresses`);
        const data = await response.json();
        if (response.ok) {
          walletAddresses = data.addresses;
        }
      } catch (error) {
        console.error('Failed to load wallet addresses:', error);
      }
    }

    // Choose file button handler
    document.getElementById('chooseFileBtn')?.addEventListener('click', () => {
      document.getElementById('proofOfDeposit').click();
    });

    // Currency select change handler
    document.getElementById('depositCurrency')?.addEventListener('change', function() {
      const currency = this.value;
      const address = walletAddresses[currency] || 'Loading...';
      document.getElementById('depositAddress').value = address;
    });

    // Copy address button handler
    document.getElementById('copyAddressBtn')?.addEventListener('click', () => {
      const addressInput = document.getElementById('depositAddress');
      addressInput.select();
      document.execCommand('copy');
      
      // Show feedback
      const btn = document.getElementById('copyAddressBtn');
      const originalHTML = btn.innerHTML;
      btn.innerHTML = '<span class="text-success-500">✓</span>';
      setTimeout(() => {
        btn.innerHTML = originalHTML;
      }, 1500);
    });

    // File input change handler
    document.getElementById('proofOfDeposit')?.addEventListener('change', function(event) {
      const file = event.target.files[0];
      if (file) {
        document.getElementById('proofFileName').textContent = file.name;
        
        const reader = new FileReader();
        reader.onload = function(e) {
          proofBase64 = e.target.result;
          const preview = document.getElementById('proofPreview');
          preview.src = proofBase64;
          preview.classList.remove('hidden');
        };
        reader.readAsDataURL(file);
      }
    });

    // Submit deposit button handler
    document.getElementById('submitDepositBtn')?.addEventListener('click', async function() {
      const currency = document.getElementById('depositCurrency').value;
      const amount = document.getElementById('depositAmount').value;
      const transactionHash = document.getElementById('transactionHash').value;
      const messageDiv = document.getElementById('depositMessage');

      if (!amount || parseFloat(amount) <= 0) {
        messageDiv.className = 'p-4 rounded-lg mb-4 bg-error-500/10 text-error-500';
        messageDiv.textContent = 'Please enter a valid amount';
        messageDiv.classList.remove('hidden');
        return;
      }

      if (!proofBase64) {
        messageDiv.className = 'p-4 rounded-lg mb-4 bg-error-500/10 text-error-500';
        messageDiv.textContent = 'Please upload proof of deposit';
        messageDiv.classList.remove('hidden');
        return;
      }

      try {
        const response = await fetch(`${API_BASE}/wallets/deposit`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            currency,
            amount: parseFloat(amount),
            proofOfPayment: proofBase64,
            txHash: transactionHash || ''
          })
        });

        const data = await response.json();

        if (response.ok) {
          messageDiv.className = 'p-4 rounded-lg mb-4 bg-success-500/10 text-success-500';
          messageDiv.textContent = 'Deposit request submitted successfully!';
          messageDiv.classList.remove('hidden');
          
          setTimeout(() => {
            window.closeDepositModal();
            loadDepositHistory();
          }, 2000);
        } else {
          messageDiv.className = 'p-4 rounded-lg mb-4 bg-error-500/10 text-error-500';
          messageDiv.textContent = data.error || 'Failed to submit deposit';
          messageDiv.classList.remove('hidden');
        }
      } catch (error) {
        console.error('Deposit error:', error);
        messageDiv.className = 'p-4 rounded-lg mb-4 bg-error-500/10 text-error-500';
        messageDiv.textContent = 'An error occurred';
        messageDiv.classList.remove('hidden');
      }
    });

    // Helper function to prevent scrolling
    function preventScroll(e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    window.openDepositModal = function(currency) {
      const modal = document.getElementById('depositModal');
      document.getElementById('depositCurrency').value = currency;
      // Update address when opening modal
      const address = walletAddresses[currency] || 'Loading...';
      document.getElementById('depositAddress').value = address;
      
      // Prevent all scrolling
      document.body.classList.add('modal-open');
      document.documentElement.style.overflow = 'hidden';
      window.addEventListener('scroll', preventScroll, { passive: false });
      window.addEventListener('wheel', preventScroll, { passive: false });
      window.addEventListener('touchmove', preventScroll, { passive: false });
      
      modal.classList.remove('hidden');
    }

    window.closeDepositModal = function() {
      document.getElementById('depositModal').classList.add('hidden');
      
      // Re-enable scrolling
      document.body.classList.remove('modal-open');
      document.documentElement.style.overflow = '';
      window.removeEventListener('scroll', preventScroll);
      window.removeEventListener('wheel', preventScroll);
      window.removeEventListener('touchmove', preventScroll);
      
      document.getElementById('depositAmount').value = '';
      document.getElementById('transactionHash').value = '';
      document.getElementById('proofOfDeposit').value = '';
      document.getElementById('proofFileName').textContent = 'No file chosen';
      document.getElementById('proofPreview').classList.add('hidden');
      document.getElementById('depositMessage').classList.add('hidden');
      proofBase64 = null;
    }

    // Withdrawal functions
    let currentWallets = [];

    window.openWithdrawModal = async function(currency) {
      const modal = document.getElementById('withdrawModal');
      document.getElementById('withdrawCurrency').value = currency;
      
      // Load and display available balance
      await updateWithdrawBalance(currency);
      
      // Prevent all scrolling
      document.body.classList.add('modal-open');
      document.documentElement.style.overflow = 'hidden';
      window.addEventListener('scroll', preventScroll, { passive: false });
      window.addEventListener('wheel', preventScroll, { passive: false });
      window.addEventListener('touchmove', preventScroll, { passive: false });
      
      modal.classList.remove('hidden');
    }

    window.closeWithdrawModal = function() {
      document.getElementById('withdrawModal').classList.add('hidden');
      
      // Re-enable scrolling
      document.body.classList.remove('modal-open');
      document.documentElement.style.overflow = '';
      window.removeEventListener('scroll', preventScroll);
      window.removeEventListener('wheel', preventScroll);
      window.removeEventListener('touchmove', preventScroll);
      
      document.getElementById('withdrawAmount').value = '';
      document.getElementById('withdrawAddress').value = '';
      document.getElementById('withdrawMessage').classList.add('hidden');
    }

    async function updateWithdrawBalance(currency) {
      try {
        const authToken = localStorage.getItem('token') || localStorage.getItem('authToken');
        console.log('=== WITHDRAWAL MODAL FETCH ===');
        console.log('Token:', authToken?.substring(0, 20) + '...');
        console.log('URL:', `${API_BASE}/wallets`);
        
        const response = await fetch(`${API_BASE}/wallets`, {
          headers: { 'Authorization': `Bearer ${authToken}` }
        });
        const data = await response.json();
        
        console.log('Response status:', response.status);
        console.log('ALL wallet data:', data); // Debug log
        
        if (response.ok && data.wallets) {
          currentWallets = data.wallets;
          const wallet = data.wallets.find(w => w.currency === currency);
          if (wallet) {
            console.log('Selected wallet for', currency, ':', wallet);
            const balance = parseFloat(wallet.balance || 0);
            const locked = parseFloat(wallet.locked_balance || 0);
            const available = balance - locked;
            console.log(`Calculated - Balance: ${balance}, Locked: ${locked}, Available: ${available}`);
            document.getElementById('withdrawAvailableBalance').textContent = available.toFixed(2) + ' ' + currency;
          } else {
            console.log('Wallet not found for currency:', currency);
          }
        }
        console.log('=== END WITHDRAWAL MODAL FETCH ===');
      } catch (error) {
        console.error('Failed to load balance:', error);
      }
    }

    // Currency change handler for withdrawal
    document.getElementById('withdrawCurrency')?.addEventListener('change', function() {
      updateWithdrawBalance(this.value);
    });

    // MAX button handler
    document.getElementById('withdrawMaxBtn')?.addEventListener('click', function() {
      const currency = document.getElementById('withdrawCurrency').value;
      console.log('MAX clicked for currency:', currency); // Debug
      console.log('Current wallets:', currentWallets); // Debug
      const wallet = currentWallets.find(w => w.currency === currency);
      console.log('Found wallet:', wallet); // Debug
      if (wallet) {
        const balance = parseFloat(wallet.balance || 0);
        const locked = parseFloat(wallet.locked_balance || 0);
        const available = balance - locked;
        console.log(`MAX: Balance: ${balance}, Locked: ${locked}, Available: ${available}`); // Debug
        document.getElementById('withdrawAmount').value = available.toFixed(2);
      } else {
        console.log('No wallet found for currency:', currency); // Debug
      }
    });

    // Submit withdrawal button handler
    document.getElementById('submitWithdrawBtn')?.addEventListener('click', async function() {
      const currency = document.getElementById('withdrawCurrency').value;
      const amount = document.getElementById('withdrawAmount').value;
      const address = document.getElementById('withdrawAddress').value;
      const messageDiv = document.getElementById('withdrawMessage');

      if (!address || address.trim() === '') {
        messageDiv.className = 'p-4 rounded-lg mb-4 bg-error-500/10 text-error-500';
        messageDiv.textContent = 'Please enter withdrawal address';
        messageDiv.classList.remove('hidden');
        return;
      }

      if (!amount || parseFloat(amount) <= 0) {
        messageDiv.className = 'p-4 rounded-lg mb-4 bg-error-500/10 text-error-500';
        messageDiv.textContent = 'Please enter a valid amount';
        messageDiv.classList.remove('hidden');
        return;
      }

      try {
        const response = await fetch(`${API_BASE}/wallets/withdraw`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            currency,
            amount: parseFloat(amount),
            address: address.trim()
          })
        });

        const data = await response.json();

        if (response.ok) {
          messageDiv.className = 'p-4 rounded-lg mb-4 bg-success-500/10 text-success-500';
          messageDiv.textContent = 'Withdrawal request submitted successfully! Awaiting admin approval.';
          messageDiv.classList.remove('hidden');
          
          setTimeout(() => {
            window.closeWithdrawModal();
            loadWithdrawalHistory();
            // Reload wallets to show locked balance
            if (window.loadWallets) window.loadWallets();
          }, 2000);
        } else {
          messageDiv.className = 'p-4 rounded-lg mb-4 bg-error-500/10 text-error-500';
          messageDiv.textContent = data.error || 'Failed to submit withdrawal';
          messageDiv.classList.remove('hidden');
        }
      } catch (error) {
        console.error('Withdrawal error:', error);
        messageDiv.className = 'p-4 rounded-lg mb-4 bg-error-500/10 text-error-500';
        messageDiv.textContent = 'An error occurred';
        messageDiv.classList.remove('hidden');
      }
    });

    window.loadWithdrawalHistory = async function() {
      try {
        const response = await fetch(`${API_BASE}/auth/withdrawals`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();

        if (response.ok) {
          const container = document.getElementById('withdrawalsList');
          
          if (data.withdrawals && data.withdrawals.length > 0) {
            container.innerHTML = data.withdrawals.map(withdrawal => {
              let statusColor = 'text-warning-500';
              let statusBg = 'bg-warning-500/10';
              let statusText = withdrawal.status.toUpperCase();
              
              if (withdrawal.status === 'approved') {
                statusColor = 'text-success-500';
                statusBg = 'bg-success-500/10';
              } else if (withdrawal.status === 'rejected') {
                statusColor = 'text-error-500';
                statusBg = 'bg-error-500/10';
              }
              
              return `
                <div class="p-4 bg-neutral-800 rounded-lg border border-neutral-700">
                  <div class="flex justify-between items-start mb-2">
                    <div>
                      <div class="text-lg font-bold text-regal-gold">${parseFloat(withdrawal.amount).toFixed(8)} ${withdrawal.currency}</div>
                      <div class="text-xs text-neutral-400">${new Date(withdrawal.created_at).toLocaleString()}</div>
                    </div>
                    <span class="px-3 py-1 rounded-full text-xs font-semibold ${statusBg} ${statusColor}">
                      ${statusText}
                    </span>
                  </div>
                  <div class="mt-2 text-xs font-mono text-neutral-400 break-all">
                    To: ${withdrawal.address}
                  </div>
                  ${withdrawal.tx_hash ? `
                    <div class="mt-1 text-xs font-mono text-neutral-400 truncate">
                      TX: ${withdrawal.tx_hash}
                    </div>
                  ` : ''}
                </div>
              `;
            }).join('');
          } else {
            container.innerHTML = '<div class="text-center text-neutral-500 py-8">No withdrawals yet</div>';
          }
        }
      } catch (error) {
        console.error('Failed to load withdrawal history:', error);
      }
    }

    window.loadDepositHistory = async function() {
      try {
        const response = await fetch(`${API_BASE}/auth/deposits`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        const data = await response.json();

        if (response.ok) {
          const container = document.getElementById('depositsList');
          
          if (data.deposits && data.deposits.length > 0) {
            container.innerHTML = data.deposits.map(deposit => {
              let statusColor = 'text-warning-500';
              let statusBg = 'bg-warning-500/10';
              let statusText = deposit.status.toUpperCase();
              
              if (deposit.status === 'completed' || deposit.status === 'confirmed') {
                statusColor = 'text-success-500';
                statusBg = 'bg-success-500/10';
                if (deposit.added_by_admin) {
                  statusText = 'ADMIN ADDED';
                }
              } else if (deposit.status === 'rejected' || deposit.status === 'failed') {
                statusColor = 'text-error-500';
                statusBg = 'bg-error-500/10';
              }
              
              return `
                <div class="p-4 bg-neutral-800 rounded-lg border border-neutral-700">
                  <div class="flex justify-between items-start mb-2">
                    <div>
                      <div class="text-lg font-bold text-regal-gold">${parseFloat(deposit.amount).toFixed(8)} ${deposit.currency}</div>
                      <div class="text-xs text-neutral-400">${new Date(deposit.created_at || deposit.createdAt).toLocaleString()}</div>
                      ${deposit.added_by_admin ? '<div class="text-xs text-success-500 mt-1">✓ Added by Admin</div>' : ''}
                    </div>
                    <span class="px-3 py-1 rounded-full text-xs font-semibold ${statusBg} ${statusColor}">
                      ${statusText}
                    </span>
                  </div>
                  ${deposit.tx_hash ? `
                    <div class="mt-2 text-xs font-mono text-neutral-400 truncate">
                      TX: ${deposit.tx_hash}
                    </div>
                  ` : ''}
                  ${deposit.proof_of_payment ? `
                    <div class="mt-2">
                      <button onclick="viewProof('${deposit.proof_of_payment}')" class="text-xs text-regal-gold hover:underline">
                        View Proof of Payment
                      </button>
                    </div>
                  ` : ''}
                </div>
              `;
            }).join('');
          } else {
            container.innerHTML = '<div class="text-center text-neutral-500 py-8">No deposits yet</div>';
          }
        }
      } catch (error) {
        console.error('Failed to load deposit history:', error);
      }
    }

    // Helper function to view proof of payment
    window.viewProof = function(proofData) {
      const modal = document.createElement('div');
      modal.className = 'fixed inset-0 bg-black/80 flex items-center justify-center z-[200] p-4';
      modal.innerHTML = `
        <div class="max-w-4xl max-h-[90vh] overflow-auto bg-neutral-900 rounded-lg p-4">
          <div class="flex justify-between items-center mb-4">
            <h3 class="text-lg font-semibold">Proof of Payment</h3>
            <button onclick="this.closest('.fixed').remove()" class="text-neutral-400 hover:text-white">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </div>
          <img src="${proofData}" alt="Proof of Payment" class="w-full h-auto rounded">
        </div>
      `;
      document.body.appendChild(modal);
      modal.addEventListener('click', function(e) {
        if (e.target === modal) modal.remove();
      });
    }

    // Load trade history (placeholder for future implementation)
    window.loadTradeHistory = async function() {
      try {
        const container = document.getElementById('tradesList');
        container.innerHTML = '<div class="text-center text-neutral-500 py-8">No trades yet</div>';
        // TODO: Implement when trading features are ready
        // const response = await fetch(`${API_BASE}/orders?status=filled`, {
        //   headers: { 'Authorization': `Bearer ${token}` }
        // });
      } catch (error) {
        console.error('Failed to load trade history:', error);
      }
    }

    // Load addresses and deposit/withdrawal history on page load
    loadWalletAddresses();
    loadDepositHistory();
    loadWithdrawalHistory();
  